import Pendingapplications from "../../../jsx/components/Dashboard/PendingApplications/pendingapplications";

const PendingApplicatiionsWrapper = () => {
  return <Pendingapplications />;
};

export default constore(PendingApplicatiionsWrapper);
